module.exports = __webpack_public_path__ + "static/media/box-dropshadow.1ba6f5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/SharedBoxHeader/assets/img/box-dropshadow.png
// module id = 443
// module chunks = 0